import ReactGA from "react-ga4"

 export const AnalyticsEventTracker = (category, action, label) => {
    const eventTracker = ReactGA.event({ category, action, label })
    return eventTracker
  }